import { render, staticRenderFns } from "./ClaimGrossResUW.vue?vue&type=template&id=0125d4bd&"
import script from "./ClaimGrossResUW.vue?vue&type=script&lang=js&"
export * from "./ClaimGrossResUW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports